import React from 'react';

import styles from './LockButton.module.css';
import { ReactComponent as LockIcon } from '../../../assets/icons/lock-open-fill.svg';

import Modal from '../../UI/Modal/Modal';
import ReopenCaseDialog from '../ReopenCaseDialog/ReopenCaseDialog';

import { Case } from '../../../interfaces/Patient';

interface Props {
    caso: Case
    disabled: boolean
    updateCase: (body: Partial<Case>) => void
}

const LockButton: React.FC<Props> = ({ caso, disabled, updateCase }) => {

    const [showReopenCase, setShowReopenCase] = React.useState(false);

    return (
        <>
            <button
                className={styles.lockContainer}
                onClick={() => setShowReopenCase(true)}
                disabled={disabled}
            >
                <LockIcon />
            </button>
            <Modal show={showReopenCase} setShowModal={setShowReopenCase}>
                <ReopenCaseDialog
                    caso={caso}
                    closeModal={() => setShowReopenCase(false)}
                    updateCase={updateCase}
                />
            </Modal>
        </>
    );
};

export default LockButton;